module.exports = __webpack_public_path__ + "img/horizontal_4_4_r_pp12_8004.4f447c11.png";